import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';
import { Button } from './ui/button';
import { Trophy } from 'lucide-react';
import { loginWithMicrosoft } from '../services/api';

function UserSelect({ error }) {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center pb-2">
          <div className="flex justify-center mb-4">
            <div className="flex h-16 w-16 items-center justify-center rounded-xl bg-primary">
              <Trophy className="h-8 w-8 text-primary-foreground" />
            </div>
          </div>
          <CardTitle className="text-3xl font-bold">
            K2 <span className="text-primary">Kudos</span>
          </CardTitle>
          <CardDescription className="text-base">
            Employee Recognition Platform
          </CardDescription>
        </CardHeader>

        <CardContent className="space-y-6">
          {error && (
            <div className="p-4 rounded-lg bg-destructive/10 text-destructive text-sm text-center">
              {error === 'no_account'
                ? 'Your Microsoft account is not linked to a K2 Kudos account. Please contact your administrator.'
                : error === 'auth_failed'
                ? 'Authentication failed. Please try again.'
                : error}
            </div>
          )}

          <div className="text-center">
            <p className="text-sm text-muted-foreground mb-6">
              Sign in with your Kids II Microsoft account to continue.
            </p>
            <Button
              onClick={loginWithMicrosoft}
              size="lg"
              className="w-full gap-3 h-12 text-base"
            >
              <svg className="h-5 w-5" viewBox="0 0 21 21" fill="none">
                <rect x="1" y="1" width="9" height="9" fill="#F25022"/>
                <rect x="11" y="1" width="9" height="9" fill="#7FBA00"/>
                <rect x="1" y="11" width="9" height="9" fill="#00A4EF"/>
                <rect x="11" y="11" width="9" height="9" fill="#FFB900"/>
              </svg>
              Sign in with Microsoft
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default UserSelect;
